export default {"src":"/_next/static/media/SIGN_AGREEMENT_ICON_GREY.16886fb4.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};